import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, getStoredToken } from "@/lib/api";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data.user);
      setProfile(res.data.profile);
      return res.data;
    } catch (e) {
      setUser(null);
      setProfile(null);
      setAuthToken(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const token = getStoredToken();
    if (token) {
      refreshMe().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [refreshMe]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setAuthToken(res.data.token);
    setUser(res.data.user);
    await refreshMe();
    return res.data;
  };

  const register = async (data) => {
    const res = await api.post("/auth/register", data);
    setAuthToken(res.data.token);
    setUser(res.data.user);
    await refreshMe();
    return res.data;
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
    setProfile(null);
  };

  return (
    <AuthContext.Provider value={{ user, profile, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};
